import React, { ReactNode, useEffect } from "react";
import { ToastContainer } from "react-toastify";

import Footer from "@/components/generic/footer";
import NavBar from "@/components/generic/navbar";
import { UserAgentContext } from "@/context/user-agent-context";
import { useIsAuthenticated } from "@/hooks/useIsAuthenticated";

interface LayoutProps {
  children: ReactNode;
  pageProps: any;
}

const Layout = ({ children, pageProps }: LayoutProps) => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      {/* Static export has no SSR: default the UA context to false so useIsMobile()
          resolves purely on the client via useWindowSize() (<992px). Consumers unchanged. */}
      <UserAgentContext.Provider value={false}>
        <NavBar isAuthenticated={isAuthenticated} />
        {children}
        <Footer />
        <ToastContainer
          position="top-center"
          autoClose={20000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnHover
          draggable
          theme="colored"
        />
      </UserAgentContext.Provider>
    </>
  );
};

export default Layout;
